import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Products.css';

const NotFound: React.FC = () => {
  return (
    <div className="products-page">
      <div className="products-intro">
        <div className="products-intro-content">
          <h1 className="products-intro-title">Page not found</h1>
          <p className="products-intro-text">
            The page you are looking for does not exist or has moved. Explore our services, industries and the Catalyst Suite from the menu, or return to the home page.
          </p>
          <p style={{ marginTop: '2rem' }}>
            <Link to="/" className="products-btn">Back to home</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
